import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

function NotFoundPage(props) {
  return (
    <div className="not_found_page top-buffer-50">
      <h1 className="text-center">
        {I18n.tr('page_not_found')}
      </h1>
    </div>
  );
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./scripts/pages/other/NotFoundPage.js